module.exports = __webpack_public_path__ + "media/dashboard/assets/images/sidebar/lightning-bolt-2eff4a7df78e8f861ec39e3ffe2e25cb.svg";